import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewChild,
  ViewEncapsulation,
  ViewRef,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from '../../../common/components/base.component';
import { PageSpinnerComponent } from '../../../common/components/page.spinner/page.spinner.component';
import { WaterFallContainerComponent } from '../../../common/components/water.fall.container/water.fall.container.component';
import { HubEvent } from '../../../models/hub/hub.event';
import { HubApiService } from '../../../services/hub.api.service';
import { ConfirmModalActions, ConfirmModalData } from '../../../common/components/confirm.modal/confirm.modal.provider';
import { ButtonTriggerEvent } from '../../../common/components';
import { ConfirmModalComponent } from '../../../common/components/confirm.modal/confirm.modal.component';
import { ModalService } from '../../../common/services/modal.service';
import { EditEventModalActions } from '../edit.event.modal/edit.event.modal.provider';
import { EditEventModalComponent } from '../edit.event.modal/edit.event.modal.component';
import { ImageService } from '../../../services/image.service';
import { HubCustomBtn } from '../../../models/hub/hub.custom.btn';
import { CustomBtnStore } from '../../../stores/hub.calendar.store';
import { CustomEventCommand } from '../../../commands/hub/custom.event.command';
import { getRouteUrl, routeConfigs } from '../../../common/constants/route.config';
import { ShowPromptModalComponent } from '../show.prompt.modal/show.prompt.modal.component';
import { PromptModalData, ShowPromptModalActions } from '../show.prompt.modal/show.prompt.modal.provider';
import { localStorageKeys } from '../../../common/constants/local.storage.keys';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { EventTimeService } from '../../../services/event.time.service';
import { isEmptyArray } from '../../../common/extensions';

@Component({
  selector: 'ig-hub-similar-calendar',
  templateUrl: './hub.similar.calendar.component.html',
  styleUrls: ['./hub.similar.calendar.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class HubSimilarCalendarComponent extends BaseComponent implements OnInit, AfterContentChecked {
  public hubName: string;
  public type: string = '';
  public events: HubEvent[] = [];
  public isAllDataLoaded: boolean;
  public isLoading: boolean;
  public isNoContent = false;
  public isNoContentFor2ParamSimilarity = false;
  public isNoContentForMultiDatesEvents = false;
  public isOperating = false;
  public similarEventsByExactSame: {
    group: HubEvent[];
    condition: SimilarCondition[];
  }[];
  public similarEventsBy2ParamSimilarity: {
    group: HubEvent[];
    condition: SimilarCondition[];
  }[];
  public similarMultiDatesEvents: {
    group: HubEvent[];
    condition: SimilarCondition[];
  }[];
  selectedTabIndex = 0;

  public customBtns = new HubCustomBtn();

  @ViewChild('spinner') private spinner: PageSpinnerComponent;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private hubApiService: HubApiService,
    private modalService: ModalService,
    public imageService: ImageService,
    public changeDetector: ChangeDetectorRef,
    private customBtnStore: CustomBtnStore
  ) {
    super({ activatedRoute });
  }

  public ngOnInit() {
    let { hubName, type } = this.allRouteParams;
    this.hubName = hubName;
    this.type = type;
    console.log('type in similar', type);

    this.customBtnStore.customBtnCommand.takeUntil(this.isDestroyed).subscribe((btns: HubCustomBtn) => {
      this.customBtns = btns || new HubCustomBtn();
    });

    this.getSimilarEvents();
  }

  public getSimilarEvents(isLoadMore = false) {
    this.showSpinner();
    this.similarEventsByExactSame = [];
    if (this.type === 'ai') {
      this.hubApiService
        .aiAssistant(this.hubName, {
          query: this.hubName,
          model: 'chatgpt',
          feature: 'checkDuplicatedEvents',
        })
        .finally(() => {})
        .subscribe((data) => {
          if (data.success) {
            const json = JSON.parse(data.data);
            console.log(json);
            console.log(data.results);

            for (const group of data.results) {
              // sometimes AI can give a group of duplicate events with only 1 event
              if (group.length > 1) {
                group.forEach((item) => {
                  EventTimeService.processEventTime(item);
                });
                this.similarEventsByExactSame.push({
                  group,
                  condition: [],
                });
              }
            }

            this.hideSpinner();
          } else {
            alert('Error when getSimilarEvents!');
            this.hideSpinner();
          }
        });
    } else {
      this.hubApiService.getSimilarEvents(this.hubName).subscribe((data) => {
        console.log(data);
        this.similarEventsByExactSame = data.similarEventsByExactSame;
        // this.similarEventsBy2ParamSimilarity = data.similarEventsBy2ParamSimilarity;
        this.similarMultiDatesEvents = data.similarMultiDatesEvents;
        this.isNoContent = !this.similarEventsByExactSame || !this.similarEventsByExactSame.length;
        // this.isNoContentForMultiDatesEvents = !this.similarMultiDatesEvents || !this.similarMultiDatesEvents.length;
        this.hideSpinner();
      });
    }
  }

  public tabChange($event: MatTabChangeEvent) {
    this.selectedTabIndex = $event.index;
    if ($event.index === 1) {
      this.getMultiDatesSimilarEvents();
    }
  }

  public getMultiDatesSimilarEvents() {
    // this.showSpinner();
    // this.hubApiService.getMultiDatesSimilarEvents(this.hubName).subscribe((data) => {
    //   console.log(data);
    //   this.similarMultiDatesEvents = data.similarMultiDatesEvents;
    //   this.isNoContentForMultiDatesEvents = !this.similarMultiDatesEvents || !this.similarMultiDatesEvents.length;
    //   this.hideSpinner();
    // });
  }

  ngAfterContentChecked() {
    this.changeDetector.detectChanges();
  }

  public getCount(type) {
    if (!type || !type.length) return 0;

    let count = 0;
    type.forEach((x) => {
      count += x.group.length;
    });
    return count;
  }

  public isSimilarField(field: string, eventId: string, conditions: SimilarCondition[]) {
    const condition = conditions.find((x) => x.field === field);
    if (!condition) return false;

    return condition.events.indexOf(eventId) >= 0;
  }

  public approve(event: HubEvent) {
    this.isOperating = true;
    this.hubApiService
      .approveEvent(this.hubName, event._id)
      .finally(() => (this.isOperating = false))
      .subscribe(() => {
        event.isApproved = true;
      });
  }

  public unApprove(event: HubEvent) {
    this.isOperating = true;
    this.hubApiService
      .unApproveEvent(this.hubName, event._id)
      .finally(() => (this.isOperating = false))
      .subscribe(() => {
        event.isApproved = false;
      });
  }

  public showEditModal(event: HubEvent) {
    let actions = <EditEventModalActions>{
      confirm: ($event: ButtonTriggerEvent, e: HubEvent, image: string) => {
        this.getSimilarEvents();
      },
    };

    event.hubName = this.hubName;
    this.modalService.show({
      component: EditEventModalComponent,
      providers: [
        { provide: EditEventModalActions, useValue: actions },
        { provide: HubEvent, useValue: event },
      ],
      panelClass: 'width-modal-2',
    });
  }

  public block(event: HubEvent) {
    let actions = <ConfirmModalActions>{
      confirm: ($event: ButtonTriggerEvent) => {
        this.hubApiService
          .block(this.hubName, event._id)
          .finally($event.complete)
          .subscribe(() => {
            this.getSimilarEvents();
            const doNotShowModal = localStorage.getItem(localStorageKeys.doNotShowRemoveSuccessfullyModal);
            if (!doNotShowModal) {
              this.showRmoveSuccessModal();
            }
          });
      },
      cancel: () => {
        this.isOperating = false;
      },
    };

    let data = <ConfirmModalData>{
      confirmModalIcon: 'warning',
      confirmModalTitle: 'Alert',
      confirmModalDescription: 'Are you sure you want to remove this event?',
      confirmModalConfirmButtonText: 'Remove',
      confirmModalCancelButtonText: 'Cancel',
      isAsync: true,
    };

    this.modalService.show({
      component: ConfirmModalComponent,
      providers: [
        { provide: ConfirmModalActions, useValue: actions },
        { provide: ConfirmModalData, useValue: data },
      ],
    });
  }

  /**
   * remove the delete event button for pulled events, as some clients are confused that if they delete an event, it will be added in the next pull
   * */
  public deletePermanently(event: HubEvent) {
    let actions = <ConfirmModalActions>{
      confirm: ($event: ButtonTriggerEvent) => {
        this.hubApiService
          .deleteEvent(this.hubName, event._id)
          .finally($event.complete)
          .subscribe(() => {
            this.getSimilarEvents();
          });
      },
      cancel: () => {
        this.isOperating = false;
      },
    };

    let data = <ConfirmModalData>{
      confirmModalIcon: 'warning',
      confirmModalTitle: 'Alert',
      confirmModalDescription:
        'Are you sure you want to delete this event permanently, this operation cannot be reverted?',
      confirmModalConfirmButtonText: 'Delete',
      confirmModalCancelButtonText: 'Cancel',
      isAsync: true,
    };

    this.modalService.show({
      component: ConfirmModalComponent,
      providers: [
        { provide: ConfirmModalActions, useValue: actions },
        { provide: ConfirmModalData, useValue: data },
      ],
    });
  }

  public isInCustomBtn(event: HubEvent, btn?: CustomEventCommand) {
    if (btn) {
      return btn.events.any((x) => x === event._id);
    } else {
      let isIn = false;
      if (this.customBtns.events) {
        for (let x of this.customBtns.events) {
          if (x.events.any((x) => x === event._id)) {
            isIn = true;
            break;
          }
        }
      }
      return isIn;
    }
  }

  public addOrRemoveToCustomBtn(event: HubEvent, btn: CustomEventCommand, index: number) {
    if (!this.isInCustomBtn(event, btn)) {
      this.hubApiService.addEventToCustomBtn(this.hubName, event._id, index).subscribe((customEvents) => {
        this.customBtns.events = customEvents;
      });
    } else {
      this.hubApiService.removeEventFromCustomBtn(this.hubName, event._id, index).subscribe((customEvents) => {
        this.customBtns.events = customEvents;
      });
    }
  }

  public async gotoTours() {
    await this.router.navigateByUrl(
      getRouteUrl(routeConfigs.hub.tours, {
        hubName: this.hubName,
      })
    );
  }

  componentAddress(event: HubEvent) {
    if (!isEmptyArray(event.address.addressComponents)) {
      const components = event.address.addressComponents.filter(
        (x) => !x.types.includes('administrative_area_level_2')
      );
      return components.map((x) => x.short_name || x.shortText).join(', ');
    }
    return event.address.address;
  }

  matchedTime(conditions: SimilarCondition[], index: number) {
    const time = conditions.find((x) => x.field === 'startTime');
    if (!time) return '';

    return time.matchedDates[index];
  }

  private showSpinner() {
    this.isLoading = true;
    this.spinner.show();
  }

  private hideSpinner() {
    setTimeout(() => {
      this.isLoading = false;
      this.spinner.hide();
    });
  }

  private showRmoveSuccessModal() {
    this.modalService.show({
      component: ShowPromptModalComponent,
      providers: [
        { provide: ShowPromptModalActions, useValue: null },
        {
          provide: PromptModalData,
          useValue: new PromptModalData('Remove successfully', null, [
            'The selected item has been successfully removed from the dashboard.',
            'You can restore this item from the Removed List at any time.',
            'While in the Removed List, this item cannot be pulled again.',
          ]),
        },
      ],
      panelClass: 'width-modal-2',
    });
  }
}

export class SimilarCondition {
  field: string;
  events: string[];
  matchedDates: string[];
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/similar.calendar/hub.similar.calendar.component.ts